export default "<img src=\"assets/icons/external-icon.png\" alt=\"External Link\" />\n"